import React from "react"
import DataTable from "../DataTable/DataTable"

class AllDashboard extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<DataTable
        endpoint={this.props.path}
        no_data_text={I18n.t('none')}
        currency_unit={I18n.t('number.currency.format.unit')}
        delimiter={I18n.t('number.currency.format.delimiter')}
        separator={I18n.t('number.currency.format.separator')}
        date_format={this.props.dateFormat}
        time_format={this.props.timeFormat} />
		);
	}

}

export default AllDashboard
